import React, { useEffect, useState } from "react";
import RobitoLogo from "../components/RobitoLogo";
import "../App.css";
import { apiPostAuth } from "../utils/api"; // Assuming resend-email endpoint requires auth

const VerifyEmailPage = () => {
  const [countdown, setCountdown] = useState(100);
  const [resending, setResending] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiPostAuth("account/check_email_verified.php");
        if(response.status === "error"){
          window.location.href = "/login";
        }else{
          if (response.is_verified === 1) {
            window.location.href = "/dashboard";
          }
        }
        
      } catch (error) {
        
      }
    };

    fetchData();
  }, []);

  // Countdown timer
  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setInterval(() => setCountdown((prev) => prev - 1), 1000);
    }
    return () => clearInterval(timer);
  }, [countdown]);

  const handleResendEmail = async () => {
    if (countdown > 0) return; // Prevent click before countdown finishes
    try {
      setResending(true);
      // Call your resend verification email endpoint (adjust if needed)
      const response = await apiPostAuth("account/resend_verification.php");
      if (response.result === 1) {
        if(response.is_verified === 1){
          window.location.href = "/dashboard";
        }else{
          alert("Verification email has been resent!");
          setCountdown(100);
        }

        
      }else{
        alert(response.message || "Failed to resend email. Please try again.");
      }

       // Restart countdown
    } catch (error) {
      alert("Failed to resend email. Please try again.");
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="auth-card">
        <RobitoLogo />
        <h2 className="form-title">Email Verification Required</h2>
        <p className="text-center mb-4" style={{ textAlign: "center", marginBottom: "1rem" }}>
        We have sent a verification link to your email address.
        Please check your inbox (including spam folder) to verify your account.
        Refresh this page if you have verified your email.
        </p>

        <button
        type="button"
        className="primary-button resend-btn"
        style={{
            opacity: countdown > 0 ? 0.7 : 1,
            cursor: countdown > 0 ? "not-allowed" : "pointer",
        }}
        onClick={handleResendEmail}
        disabled={countdown > 0 || resending}
        >
        {countdown > 0
            ? `Resend Email (${countdown}s)`
            : resending
            ? "Resending..."
            : "Resend Email"}
        </button>


        <div className="copyright">© Robito.Ai 2026</div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
